import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MultiAccessSameSettings from '../same-settings';
import Button from 'common/components/elements/buttons/primary';
import RadioLabel from 'common/components/elements/inputs/radio-label';

import '../style.scss';


const ItemWrapper = ({
   contentType,
   radioLableProps,
   children,
   title,
   className,
}) => {

   const getWrraperClassName = () => {
      return cx({
         'flex border-box rounded-lg mt-2 bg-grey-main access-radio-content !p-4 access-items-end': true,
         'access-radio-content access-items-end': ['mass_message', 'store', 'chat'].includes(contentType),
         'flex-col': contentType === 'chat',
         '!cursor-pointer': !radioLableProps.checked,
         [className]: !!className,
      })
   }

   if('chat' === contentType){
      return (
         <div className={ getWrraperClassName() }>
            <RadioLabel
               { ...radioLableProps }
               isShowBorder={ false }
               className='!p-0'
               radioParentClassName='flex justify-center !m-0'
            >
               <div className='flex flex-1 flex-col'>
                  <AccessItemTitle
                     contentType={ contentType }
                     isCheckd={ radioLableProps?.checked }
                     title={ title }
                  />
               </div>
            </RadioLabel>
            {
               children && children
            }
         </div>
      )
   }
   return (
      <RadioLabel
         { ...radioLableProps }
         className={ getWrraperClassName() }
         radioParentClassName='flex justify-center !m-0'
      >
         <div className='flex flex-1 flex-col'>
            <AccessItemTitle
               contentType={ contentType }
               isCheckd={ radioLableProps?.checked }
               title={ title }
            />
            {
               children && children
            }
         </div>
      </RadioLabel>
   )
}

const AccessItemTitle = ({
   contentType,
   isCheckd,
   title,
}) => {
   return (
      <span
         className={ cx({
            'leading-5': true,
            'text-major': !['mass_message', 'store'].includes(contentType),
            'text-major text-base': ['mass_message', 'store'].includes(contentType),
            'mx-px2': isCheckd && !['mass_message', 'store'].includes(contentType),
         }) }
      >
         {title}
      </span>
   )
}

const AllAccessItem = ({
   all,
   moreState,
   contentType,
   isMobile,
   showPrerelease,
   showDownload,
   videoType,
   openEditModal,
   isActiveMember,
   getOthersLabel,
   globalDisabled,
   globalDisabledTooltipText,
}) => {
   return (
      <>
         {
            all && (
               <MultiAccessSameSettings
                  showNewStyles={ contentType === 'mass_message' }
                  title={ isActiveMember ? 'All memberships' : getOthersLabel() }
                  type={ isActiveMember ? 'all_memebrs' : 'all_others' }
                  isActiveMember={ isActiveMember }
                  state={ moreState[all.type] }
                  data={ all }
                  contentType={ contentType }
                  isMobile={ isMobile }
                  showPrerelease={ showPrerelease }
                  showDownload={ showDownload }
                  videoType={ videoType }
               />
            )
         }
         {
            contentType === 'store' && isActiveMember && all?.cancelled_pay_more_to_unlock && (
               <MultiAccessSameSettings
                  title='Canceled'
                  isActiveMember={ isActiveMember }
                  type={ isActiveMember ? 'all_memebrs' : 'all_others' }
                  state={ moreState.locked }
                  data={ all }
                  contentType={ contentType }
                  isMobile={ isMobile }
                  showPrerelease={ false }
                  showDownload={ false }
                  videoType={ '' }
                  showPercentage
               />
            )
         }
         <div className={ `flex items-end justify-end w-full ${ ['mass_message'].includes(contentType) ? 'mt-0' : 'mt-4' } relative h-9` }>
            <div
               style={ {
                  right: contentType === 'chat' ? 0 : '-28px',
               } }
               className={ 'h-full absolute' }>
               <Button
                  text='Edit'
                  primaryColor
                  backgroundColor='transparent'
                  textSize={ ['mass_message', 'store'].includes(contentType) ? 'small' : 'base' }
                  textClassName={ `${ ['mass_message', 'store'].includes(contentType) ? 'leading-5' : '' } pl-2` }
                  textMarginX='0'
                  iconName='pencil'
                  iconPosition='left'
                  fontIconSize={ ['mass_message', 'store'].includes(contentType) ? 'extraLarge' : 'large' }
                  padding='none'
                  classNames={ cx({
                     'h-full py-2 px-3.5': true,
                     'w-[82px]': ['mass_message', 'store'].includes(contentType),
                     'intercom-chat-settings-edit': contentType === 'chat',
                  }) }
                  onClick={ _ => openEditModal('all') }
                  disabled={ globalDisabled }
                  dataToolTipContent={ globalDisabledTooltipText }
               />
            </div>
         </div>
      </>
   )
}

const DifferentAccessItems = ({
   different,
   cancelChackbox,
   moreState,
   contentType,
   isMobile,
   showPrerelease,
   showDownload,
   videoType,
   openEditModal,
   globalDisabled,
   globalDisabledTooltipText,
}) => {
   return (
      <>
         {
            different && !!Array.isArray(different) && different.map((item, index) => {
               if(cancelChackbox && item.type === 'free') return null
               const { access } = item
               if(!access) return null
               if(!moreState[access.type]) return null
               let description = null;
               if(access.type === 'not_available'){
                  if('expired' === item.type) description = 'Not available to expired membership'
                  if('guest' === item.type) description = 'Not available to guests'
                  if(item.id) description = 'Not available to this memebrship'
               }
               return (
                  <MultiAccessSameSettings
                     key={ index.toString() || index.toString() }
                     title={ item.name }
                     type={ item.type || item.id }
                     description={ description }
                     state={ moreState[access.type]  || {} }
                     data={ access }
                     contentType={ contentType }
                     isMobile={ isMobile }
                     showPrerelease={ showPrerelease }
                     showDownload={ showDownload }
                     videoType={ videoType }
                  />
               )
            })
         }
         <div className='flex items-end justify-end w-full mt-4 relative h-9'>
            <div
               style={ {
                  right: contentType === 'chat' ? 0 : '-28px',
               } }
               className='h-full absolute'>
               <Button
                  text='Edit'
                  primaryColor
                  backgroundColor='transparent'
                  textSize='small'
                  iconName='pencil'
                  textMarginX='0'
                  textClassName='pl-2'
                  iconPosition='left'
                  fontIconSize='extraLarge'
                  padding='none'
                  classNames={ cx({
                     'h-full  py-2 px-3.5': true,
                     'intercom-chat-settings-edit': contentType === 'chat',
                  }) }
                  onClick={ _ => openEditModal('different') }
                  disabled={ globalDisabled }
                  dataToolTipContent={ globalDisabledTooltipText }
               />
            </div>
         </div>
      </>
   )
}

AccessItemTitle.propTypes = {
   contentType: PropTypes.string,
   title: PropTypes.string,
   isCheckd: PropTypes.bool,
};
ItemWrapper.propTypes = {
   title: PropTypes.string,
   contentType: PropTypes.string,
   radioLableProps: PropTypes.object,
   children: PropTypes.any,
   className: PropTypes.string,
};
AllAccessItem.propTypes = {
   type: PropTypes.oneOf(['active', 'public']),
   openEditModal: PropTypes.func,
   moreState: PropTypes.object,
   all: PropTypes.object,
   contentType: PropTypes.string,
   isMobile: PropTypes.bool,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   isActiveMember: PropTypes.bool,
   videoType: PropTypes.string,
   getOthersLabel: PropTypes.func,
   globalDisabled: PropTypes.bool,
   globalDisabledTooltipText: PropTypes.string,
};

DifferentAccessItems.propTypes = {
   openEditModal: PropTypes.func,
   moreState: PropTypes.object,
   different: PropTypes.array,
   contentType: PropTypes.string,
   isMobile: PropTypes.bool,
   cancelChackbox: PropTypes.bool,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   videoType: PropTypes.string,
   globalDisabled: PropTypes.bool,
   globalDisabledTooltipText: PropTypes.string,
};
export { DifferentAccessItems, AllAccessItem, ItemWrapper };
